import { hasPermission, UserRole } from './rolePermissions';

/**
 * Utility functions for working with routes
 */

/**
 * Filters routes to only include those that should be visible in the sidebar
 * and that the user has permission to access
 * @param routes - Array of route objects
 * @param userRole - Current user's role
 * @returns Array of routes that should be shown in sidebar
 */
export const getVisibleSidebarRoutes = (routes: RoutesType[], userRole: string | null = null): RoutesType[] => {
    return routes.filter(route => {
        // First check if route should be shown in sidebar
        if (route.showInSidebar === false) {
            return false;
        }

        // Then check if user has permission to access this route
        if (userRole && route.allowedRoles) {
            return hasPermission(userRole as UserRole, route.allowedRoles);
        }

        // If no role restrictions defined, show the route
        return true;
    });
};

/**
 * Filters routes to only include those that should be hidden from the sidebar
 * @param routes - Array of route objects
 * @returns Array of routes that should be hidden from sidebar
 */
export const getHiddenSidebarRoutes = (routes: RoutesType[]): RoutesType[] => {
    return routes.filter(route => route.showInSidebar === false);
};

/**
 * Checks if a specific route should be visible in the sidebar
 * @param route - Route object to check
 * @param userRole - Current user's role
 * @returns Boolean indicating if route should be visible in sidebar
 */
export const shouldShowInSidebar = (route: RoutesType, userRole: string | null = null): boolean => {
    // First check if route should be shown in sidebar
    if (route.showInSidebar === false) {
        return false;
    }

    // Then check if user has permission to access this route
    if (userRole && route.allowedRoles) {
        return hasPermission(userRole as UserRole, route.allowedRoles);
    }

    // If no role restrictions defined, show the route
    return true;
};
